// Networking helpers
// Robust version compatible with all usages (App.jsx, ResultsViewer, etc)
export async function fetchTextWithDiagnostics(
  url,
  opts = {},
  { timeoutMs = 12000 } = {}
) {
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, {
      mode: "cors",
      ...opts,
      signal: controller.signal,
    });
    const text = await res.text().catch(() => "");
    return { ok: res.ok, status: res.status, statusText: res.statusText, text };
  } catch (e) {
    return {
      ok: false,
      status: 0,
      statusText: String(e?.message ?? "Network error"),
      text: "",
    };
  } finally {
    clearTimeout(t);
  }
}

export function safeArr(x) {
  return Array.isArray(x) ? x : [];
}

export function stripCodeWrappers(text) {
  return text
    .replace(/^```[\w]*\n?/g, "")
    .replace(/\n?```$/g, "");
}

export function looksLikeCode(text) {
  return /[{};\[\]()]/.test(text);
}

export function guessLang(text) {
  if (/\b(function|const|let|var|=>|import|export)\b/.test(text)) return "javascript";
  if (/\b(class|public|private|void|int|String)\b/.test(text)) return "java";
  if (/\b(def|import|print|self)\b/.test(text)) return "python";
  if (/^(SELECT|INSERT|UPDATE|DELETE|CREATE)\b/i.test(text)) return "sql";
  return "markup";
}
